import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    androidInfo: '',
    iosInfo: '',
    plistInfo: '',
    totalCount:0,
    pagination: {page: 1,size: 25},
    infoList: [],
    updateInfo:{}
  },
  mutations: {

    setAppInfo(state, payload) {
      state[
        payload.platform === 'android'
          ? 'androidInfo'
          : payload.platform === 'apple'
            ? 'iosInfo'
            : 'plistInfo'
      ] =
        payload.data;
    },

    setPagination(state, payload) {
      state.pagination = payload;
    },

    setCountTotal(state, payload) {
      state.totalCount = payload;
    },

    setInfoList(state, payload) {
      state.infoList = payload;
    },

    setUpdateInfo(state, payload) {
      state.updateInfo = payload;
    }

  },
  actions: {

    info({ commit }, platform) {
      api.getAppInfo(platform).then(({ data }) => {
        commit('setAppInfo', { platform, data });
      });
    },

    list({ commit },query) {
      commit('setPagination',{ page: query.page, size: query.size });
      api.getInfoList(query).then(response => {
        commit('setCountTotal',response.data.totalCount);
        commit('setInfoList',response.data.list);
      })
    },

    update({ commit },info) {
      api.updateInfo(info);
    },

    remove({ commit },data) {
      api.removeInfo(data);
    },

    buildUpdateInfo({ commit },data) {
      commit('setUpdateInfo',data);
    },

    getNewestVersion() {
      return api.getNewestVersion();
    }
  }
};

appStore.registerModule('app', store);
